import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { stateKeys } from '../../constants';
import { useStateControllers } from '../../stateManager';

const noop = () => {};

const key = stateKeys.pageSize;

const Context = createContext();

export const usePageSizeHandler = () => useContext(Context);

export const PageSizeProvider = ({ children, ...props }) => {
  const { value, onChange = noop, defaultValue } = props ?? {};

  const isControlledRef = useRef(Object.hasOwn(props, 'value'));

  const { setValue } = useStateControllers();

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const handler = useCallback(
    (value) => {
      onChangeRef.current(value);

      if (!isControlledRef.current) {
        setValue(key, value);
      }
    },
    [setValue]
  );

  useEffect(() => {
    if (isControlledRef.current) {
      setValue(key, value);
    } else if (defaultValue) {
      setValue(key, defaultValue);
    }
  }, [value, defaultValue, setValue]);

  return <Context.Provider value={handler}>{children}</Context.Provider>;
};
